export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_EXPIRED_TIME = 'SET_EXPIRED_TIME';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const FETCH_OBJECTS_START = 'FETCH_OBJECTS_START';
export const FETCH_NEW_OBJECTS_START = 'FETCH_NEW_OBJECTS_START';
export const FETCH_MORE_OBJECTS_START = 'FETCH_MORE_OBJECTS_START';
export const FETCH_OBJECTS_SUCCESS = 'FETCH_OBJECTS_SUCCESS';
export const FETCH_OBJECTS_CONFIGS = 'FETCH_OBJECTS_CONFIGS';
export const FETCH_OBJECTS_TOTAL = 'FETCH_OBJECTS_TOTAL';
export const FETCH_MORE_OBJECTS_SUCCESS = 'FETCH_MORE_OBJECTS_SUCCESS';
export const PUSH_CURRENT_STATE_OBJECTS = 'PUSH_CURRENT_STATE_OBJECTS';
export const PUSH_CURRENT_CLASSES_OBJECTS = 'PUSH_CURRENT_CLASSES_OBJECTS';
export const FETCH_OBJECTS_FAIL = 'FETCH_OBJECTS_FAIL';
export const FETCH_OBJECTS_FINISH = 'FETCH_OBJECTS_FINISH';

export const FETCH_DEVICE_CONFIG_START = 'FETCH_DEVICE_CONFIG_START';
export const FETCH_DEVICE_CONFIG_FINISH = 'FETCH_DEVICE_CONFIG_FINISH';
export const FETCH_DEVICE_CONFIG_FAIL = 'FETCH_DEVICE_CONFIG_FAIL';
export const FETCH_DEVICE_CONFIG_SUCCESS = 'FETCH_DEVICE_CONFIG_SUCCESS';
export const FETCH_USER_PLAN_DEVICE_SUCCESS = 'FETCH_USER_PLAN_DEVICE_SUCCESS';
export const FETCH_USER_PLAN_SUCCESS = 'FETCH_USER_PLAN_SUCCESS';
export const FETCH_USER_PLAN_FINISH = 'FETCH_USER_PLAN_FINISH';
export const ADD_CONTROLLER_STATION_IDS = 'ADD_CONTROLLER_STATION_IDS';
export const FETCH_CONTROLLER_STATION_IDS = 'FETCH_CONTROLLER_STATION_IDS';
export const FETCH_OUTLET_REFRESH = 'FETCH_OUTLET_REFRESH';

export const SETTINGS_FETCH = 'SETTINGS_FETCH';